import React from "react";

const footer = () => {
  return (
    <div className="row justify-content-center">
      <h4 className="text-white p-2 text-center fs-6">
        Copyright 2024 - Designed with ❤️ by{" "}
        <a
          href="https://kumarabhijeett.blogspot.com/"
          className="text-white owner-info"
          target="blank"
        >
          Abhijeet Kumar
        </a>
      </h4>
    </div>
  );
};

export default footer;
